<template>
    <div class="container">
        <div id="checkout-bar" class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <ul class="nav nav-pills nav-justified">
                    <template v-for="step in steps">
                        <li v-bind:key="step.name" :class="getStep(step,route.name).class">
                            <component :is="!getStep(step,route.name).disabled ? 'router-link' : 'a'" rel="nofollow" :to="{ name: step.name }" :class="getStep(step,route.name).disabled ? 'btn' : ''" :disabled="getStep(step,route.name).disabled ? true : false">
                                {{ labels[step.label] }}
                            </component>
                        </li>
                    </template>

                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import useProgress from "../composables/useProgress"
import useCMS from "../../shared/composables/useCMS"
import { computed } from '@vue/composition-api'

export default {
    name: 'CartProgressBar',
    setup (props,{root}) {
        const { steps, getStep } = useProgress();
        const { labels } = useCMS();
        const route = computed(() => {
            return root._route;
        });

        return {
            labels,
            steps,
            getStep,
            route
        }
    }
}
</script>
